// packages/shared-hooks/src/leads/useLeadArtifacts.ts
//
// `GET /leads/:id/artifacts` — the flat, newest-first list of artifacts
// (China/Russia requests, Deals, external intake submissions) linked to a
// Lead (#2314). The backend resolves Lead visibility FIRST (404 on miss) and
// filters each child kind by its own aggregate's predicate, so reaching this
// data means the actor is cleared to read the Lead. Mirrors
// `useLeadIntakeHistory`.
import { useQuery } from '@tanstack/react-query';
import { GetLeadArtifactsResponseSchema, type GetLeadArtifactsResponse } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { leadsKeys } from './keys.js';

export function useLeadArtifacts(id: string | null, opts?: { enabled?: boolean }) {
  const client = useApiClient();
  return useQuery<GetLeadArtifactsResponse>({
    queryKey: leadsKeys.artifacts(id ?? ''),
    enabled: (opts?.enabled ?? true) && !!id,
    queryFn: ({ signal }) =>
      client.get<GetLeadArtifactsResponse>(
        `/leads/${id}/artifacts`,
        { signal },
        GetLeadArtifactsResponseSchema,
      ),
  });
}
